
export const projects = [
    {  
        name : 'Blog Design Template',
        description : 'Blog Template Using HTML,CSS & JQUERY',         
        githubLink : 'https://github.com/Abdulrahaman1000/Blog-Website-Design-Templatee/tree/master' ,
        liveSite : 'https://abdulrahmanblogwebsitetemplate.netlify.app/' ,
        image : 'assets/blogDesignTemplate.png'
    },
    {  
        name : ' Laravel Blog Website',
        description : 'Fullstack Blog Website Using Laravel, Boostap & TailWind',        
        githubLink : '' ,
        liveSite : '' ,
        image : 'assets/LARAVEL.png'
    },
    {  
        name : 'Personal Portfolio',
        description : 'full stack User Authentication Website Using  PHP & MSQL',       
        githubLink : '' ,
        liveSite : 'http://abdulrahmanportfolio.epizy.com/LoginRegistration/?i=2' ,
        image : 'assets/UserReg.png'
    },
    {  
        name : 'Video Sharing Website Like Youtube',
        description : 'Video sharing Website Using React Js',     
        githubLink : '' ,
        liveSite : '' ,
        image : 'assets/youtube player.png'
    },
    {  
        name : 'Movie Template Design',
        description : 'Movie template Design Using HTML,CSS & JS',     
        githubLink : '' ,
        liveSite : 'https://abdulmovies.netlify.app/' ,
        image : 'assets/MovieDesignTemplate.png'
    },
    {  
        name : 'Bootstrap Blog Design Template',
        description : 'Bootsatrap Design with Jquery',        
        githubLink : 'https://github.com/Abdulrahaman1000/Blog3TemplateDesign/tree/master' ,
        liveSite : 'https://abdulblog2.netlify.app/' ,
        image : 'assets/BoostrapBlogDesign.png'
    },
    {  
        name : 'Resume Website',
        description : 'Resume Website Uisng React Js',        
        githubLink : '' ,
        liveSite : 'https://myresumetemplate.netlify.app/',
        image : 'assets/resume.png'
    },

    {  
        name : 'LARAVEL8 BLOG WEBSITE',
        description : 'progressive web application',        
        githubLink : '' ,
        liveSite : '' ,
        image : 'assets/laravel.png'
    },
    {  
        name : 'My First Portdolio website',
        description : 'Boostrap Portfolio',        
        githubLink : '' ,
        liveSite : '' ,
        image : 'assets/MyFirstP.png'
    },
    

]